import React, { useState } from 'react'
import { ArticleForm } from '../components/forms'

const EditArticle = props => {
    const [saveAndNotify, setSaveAndNotify] = useState(false)

    return (
        <ArticleForm
            articleId={props.match.params.id}
            submitButtonProps={{
                label: saveAndNotify ? 'Save and notify' : 'Save',
            }}
            updateSaveAndNotify={setSaveAndNotify}
            allowUploads
        />
    )
}

export default EditArticle
